import React from "react";

import CampaignIcon from "@mui/icons-material/Campaign";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import FolderIcon from "@mui/icons-material/Folder";
import GridViewIcon from "@mui/icons-material/GridView";
import HomeIcon from "@mui/icons-material/Home";
import LocalAtmIcon from "@mui/icons-material/LocalAtm";
import LocalShippingIcon from "@mui/icons-material/LocalShipping";
import PersonIcon from "@mui/icons-material/Person";
import SchoolIcon from "@mui/icons-material/School";
import StickyNote2Icon from "@mui/icons-material/StickyNote2";
import SupervisorAccountIcon from "@mui/icons-material/SupervisorAccount";
import Divider from "@mui/material/Divider";
import MuiDrawer from "@mui/material/Drawer";
import IconButton from "@mui/material/IconButton";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import { styled } from "@mui/material/styles";
import Toolbar from "@mui/material/Toolbar";
import CryptoJS from "crypto-js";

import FloatingImpersonateButton from "./FloatingImpersonateButton";
import ImpersonateModal from "./ImpersonateModal";

const drawerWidth = 290;

const Drawer = styled(MuiDrawer, {
  shouldForwardProp: (prop) => prop !== "open",
})(({ theme, open }) => ({
  overflow: "hidden",
  "& .MuiDrawer-paper": {
    position: "relative",
    whiteSpace: "nowrap",
    width: drawerWidth,
    transition: theme.transitions.create("width", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
    boxSizing: "border-box",
    ...(!open && {
      overflowX: "hidden",
      transition: theme.transitions.create("width", {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen,
      }),
      width: theme.spacing(0),
      [theme.breakpoints.up("sm")]: {
        width: theme.spacing(0),
      },
    }),
  },
}));

const DrawerMobile = styled(MuiDrawer, {
  shouldForwardProp: (prop) => prop !== "open",
})(({ theme, open }) => ({
  "& .MuiDrawer-paper": {
    position: "absolute",
    whiteSpace: "nowrap",
    width: drawerWidth,
    transition: theme.transitions.create("width", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
    boxSizing: "border-box",
    ...(!open && {
      overflowX: "hidden",
      transition: theme.transitions.create("width", {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen,
      }),
      width: theme.spacing(0),
      [theme.breakpoints.up("sm")]: {
        width: theme.spacing(0),
      },
    }),
  },
}));

const Navigation = ({ open, toggleDrawer, handlePagina, handlePaginaMobile, isMobile }) => {
  const DrawerComponent = isMobile ? DrawerMobile : Drawer;
  const handlePageChange = isMobile ? handlePaginaMobile : handlePagina;
  const [impersonateModalOpen, setImpersonateModalOpen] = React.useState(false);

  let user = CryptoJS.AES.decrypt(localStorage.getItem("user"), "MedSys@341");
  user = CryptoJS.enc.Utf8.stringify(user);

  const isMedSystems = user === "05273422000154";

  const handleImpersonateClick = () => {
    setImpersonateModalOpen(true);
    localStorage.setItem("is_impersonating", "true");
  };

  const handleCloseImpersonateModal = () => {
    setImpersonateModalOpen(false);
  };

  const handleMenuItemClick = (page, customOnClick) => {
    if (customOnClick) {
      customOnClick();
    } else {
      handlePageChange(page);
    }

    if (isMobile && open) {
      toggleDrawer();
    }
  };

  const menuItems = [
    ...(isMedSystems
      ? [
          {
            text: "Visualizar como Cliente",
            icon: <SupervisorAccountIcon />,
            onClick: handleImpersonateClick,
          },
        ]
      : []),
    { text: "Painel", icon: <HomeIcon />, page: 8 },
    { text: "Comunicados", icon: <CampaignIcon />, page: 9 },
    { text: "Financeiro", icon: <LocalAtmIcon />, page: 1 },
    { text: "Pedidos", icon: <LocalShippingIcon />, page: 2 },
    { text: "Consumíveis", icon: <GridViewIcon />, page: 7 },
    { text: "Treinamentos", icon: <SchoolIcon />, page: 5 },
    { text: "Apoio Marketing", icon: <FolderIcon />, page: 3 },
    { text: "Ordens de Serviço", icon: <StickyNote2Icon />, page: 6 },
    { text: "Conta e Perfil", icon: <PersonIcon />, page: 4 },
  ];

  return (
    <>
      <DrawerComponent variant="permanent" open={open}>
        <Toolbar>
          <IconButton onClick={toggleDrawer}>
            <ChevronLeftIcon />
          </IconButton>
        </Toolbar>
        <Divider />
        <List>
          {menuItems.map((item) => (
            <ListItem
              button
              key={item.text}
              onClick={() => handleMenuItemClick(item.page, item.onClick)}
            >
              <ListItemIcon>{item.icon}</ListItemIcon>
              <ListItemText primary={item.text} />
            </ListItem>
          ))}
        </List>
        <FloatingImpersonateButton onClick={handleImpersonateClick} />
      </DrawerComponent>
      <ImpersonateModal open={impersonateModalOpen} onClose={handleCloseImpersonateModal} />
    </>
  );
};

export default Navigation;
